<template>
  <div>
    <SyncStateIcon
      v-if="anyUnsyncedItems"
      :isItemUnsynced="isVoyageUnsynced(voyage)"
    />
    <v-chip
      class="ml-2 align-self-center"
      :color="getStatusColour(voyage.status)"
      text-color="white"
      >{{ voyage.status | pascalToReadable }}</v-chip
    >
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          v-show="voyage.isValid != undefined"
          class="ml-2"
          large
          :color="voyage.isValid ? 'success' : 'warning'"
          v-bind="attrs"
          v-on="on"
          >{{
            voyage.isValid
              ? "mdi-check-circle-outline"
              : "mdi-alert-circle-outline"
          }}</v-icon
        >
      </template>
      <span>{{
        voyage.isValid ? "Passed Validation Checks" : "Validation Errors Found"
      }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import StatusColourMixin from '../../mixins/StatusColourMixin';
import VoyageReportsHelperMixin from '../../mixins/VoyageReportsHelperMixin';
import SyncStateIcon from '../ui/SyncStateIcon.vue';

export default {
  name: 'VoyageListCardStatus',
  components: { SyncStateIcon },
  mixins: [VoyageReportsHelperMixin, StatusColourMixin],
  props: {
    voyage: {
      type: Object,
      required: true,
    },
  },
};
</script>
